// Module
var code = "<div id=\"tree\"> </div>";
// Exports
export default code;